import { createContext } from "react";

const OtaContext = createContext();

export default OtaContext;
